import { render, staticRenderFns } from "./PlayerPendingInfoRewardForVip.vue?vue&type=template&id=e777392c&scoped=true&"
import script from "./PlayerPendingInfoRewardForVip.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingInfoRewardForVip.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPendingInfoRewardForVip.vue?vue&type=style&index=0&id=e777392c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e777392c",
  null
  
)

export default component.exports